export type TerminologyKeys = {
  chatDriver: string;
  chatDriverUrlSlug: string;
  chatDriverQueryParam: string;
};

export const getTerminology = (): TerminologyKeys => ({
  chatDriver: 'Topic',
  chatDriverUrlSlug: 'topic',
  chatDriverQueryParam: 'topic',
});
